"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const usehooks_ts_1 = require("usehooks-ts");
const useAsyncFetch_1 = __importDefault(require("./useAsyncFetch"));
function useAsyncIntervalFetch(fnFetch, millis, options, dependencies) {
    const [intervalCount, setIntervalCount] = (0, react_1.useState)(0);
    const depsList = (0, react_1.useMemo)(() => {
        let list = [intervalCount];
        list = list.concat(dependencies || []);
        return list;
    }, [intervalCount, dependencies]);
    const fetchAction = (0, useAsyncFetch_1.default)(fnFetch, options, depsList);
    const isIntervalEnabled = !fetchAction.isLoading;
    (0, usehooks_ts_1.useInterval)(() => {
        fetchAction.reset();
        setIntervalCount(intervalCount + 1);
    }, isIntervalEnabled ? millis : null);
    return fetchAction;
}
exports.default = useAsyncIntervalFetch;
